import {
  IButtonPropertyOptions,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/ButtonPropertyTypeStrategy/types/IButtonPropertyTypeInterfaces'

export interface IButtonPropertyPresentation {
  label: string
}

export function getButtonPropertyPresentation(
  options: IButtonPropertyOptions | null | undefined,
  propertyTitle: string | null | undefined,
): IButtonPropertyPresentation {
  return {
    label: (options?.label || '').trim() || (propertyTitle || '').trim(),
  }
}
